import { LaiSuatText } from "constants/choVayConst";
import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { nFormatter } from "utils/currencyFormat";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { catChuoi } from "utils/stringExtension";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachhang } from "./ChiTietKhachHang/BtnChiTietKhachhang";
import { BtnSuaTinChap } from "./ChucNang/Sua/SuaTinChap/BtnSuaTinChap";
import { BtnSuaCamDo } from "./ChucNang/Sua/SuaCamDo/BtnSuaCamDo";
// import { BtnSuaTinChap } from "./ChucNang/Sua/SuaTinChap/BtnSuaTinChap";
// import BtnSuaTraGop from "./ChucNang/Sua/SuaTraGop/BtnSuaTraGop";
import { BtnSuaTraGop } from "./ChucNang/Sua/SuaTraGop/BtnSuaTraGop";
import { BtnXacNhanDuyet } from "./ChucNang/XacNhanDuyet/BtnXacNhanDuyet";
import { BtnXacNhanGiaoTien } from "./ChucNang/XacNhanGiaoTien/BtnXacNhanGiaoTien";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";

export const ContentTable = ({
  listHopDongChoDuyetFull,
  quyenDuyet,
  quyenXacNhan,
  quyenSua,
  quyenXoa,
  quyenChiTietHopDong,
  quyenChiTietKhachHang,
  showFormTraGop,
  showFormTinChap,
  inthuchi,
  phanquyen,
  showFormCamDo,
  showModalLoaiTaiSan,
  loaitaisan,
  isDuDungPhiPhatDongLaiTatToan,
  isSuDungTatToanSom,
  isSuDungCongTacVienNhanVien,
  SuDungPhiPhat_DongLai_Cham,
}) => {
  const [isModalVisible, setModalVisible] = useState(false);

  return listHopDongChoDuyetFull.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-8 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center">{index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-15-6-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center">
            <BtnChiTietHopDong
              item={item}
              quyenChiTietHopDong={quyenChiTietHopDong}
            />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-12-8-sm">
        <span className="mobile-column-name">Tên khách hàng</span>
        <div className="center-wrapper">
          <p className="Text-left">
            <BtnChiTietKhachhang
              item={item}
              quyenChiTietKhachHang={quyenChiTietKhachHang}
            />
            <br />
             {item.Phone}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-14 flex-basis-11-2-sm">
        <span className="mobile-column-name">Tên tài sản</span>
        <div className="center-wrapper">
          <p className="text-center">{catChuoi(item.TaiSan, 10)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-13 flex-basis-12-sm">
        <span className="mobile-column-name">Thời gian</span>
        <div className="center-wrapper">
          <p className="text-center">
            {getDate(item.NgayVay)}
            <br /> {getDate(item.NgayTra)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-17 flex-basis-15-8-sm">
        <span className="mobile-column-name">Số tiền vay</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span className="color-do-bold">{formatNumber(item.Sotienvay)}</span> <br />{" "}
            {item.Type !== 2 && (
              // <span className="font-lai">
              //   (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
              // </span>
              <>
                {item.IsDuNoGiamDan == true && (
                  <span className="font-lai">
                    {"Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"}
                  </span>
                )}
                {(item.IsDuNoGiamDan == undefined ||
                  item.IsDuNoGiamDan == false) && (
                  <span className="font-lai">
                    (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                  </span>
                )}
              </>
            )}
            {item.Type === 2 && (
              <span className="font-lai">
                (
                {item.StatusPaidHo === 1 &&
                  "Lãi thiếu: " +
                    nFormatter(Math.ceil(item.ValueLai * item.CountTypePaid))}
                {item.StatusPaidHo === 2 &&
                  "Lãi đủ: " + nFormatter(item.ValueLai * item.BocTrongVong)}
                {item.StatusPaidHo === 3 &&
                  "Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"}
                )
              </span>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-15-sm">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper">
          <p className="text-center">
            {item.Status === 5 && (
              <span className="cho-nhan">Chờ duyệt vay</span>
            )}
            {item.Status === 6 && (
              <span className="da-nhan">Chờ nhận tiền</span>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-11-6-sm  action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {quyenSua && item.Type === 1 && (
              <BtnSuaTinChap
                item={item}
                showFormTinChap={showFormTinChap}
                isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
                SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
                isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
                isSuDungTatToanSom={isSuDungTatToanSom}
              />
            )}
            {quyenSua && item.Type === 2 && (
              <BtnSuaTraGop
                item={item}
                showFormTraGop={showFormTraGop}
                // inthuchi={inthuchi}
                // phanquyen={phanquyen}
                isModalVisible={isModalVisible}
                setModalVisible={setModalVisible}
                isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
                SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
                isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
                isSuDungTatToanSom={isSuDungTatToanSom}
              />
            )}

            {quyenSua && item.Type === 3 && (
              <BtnSuaCamDo
                item={item}
                showFormCamDo={showFormCamDo}
                showModalLoaiTaiSan={showModalLoaiTaiSan}
                loaitaisan={loaitaisan}
                isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
                SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
                isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
                isSuDungTatToanSom={isSuDungTatToanSom}
              />
            )}

            {quyenXacNhan && item.Status === 6 && (
              <BtnXacNhanGiaoTien item={item} />
            )}
            {quyenDuyet && item.Status === 5 && <BtnXacNhanDuyet item={item} />}

            {quyenXoa && <BtnXoa item={item} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
